import {
  TrainingService,
  ServiceType,
  TrainingType,
  ServiceStatus,
} from '../models/TrainingService'
import { User, UserRole } from '../models/User'
import { Project, ProjectStatus } from '../models/Project'
import { RosterEntry } from '../models/Roster'
// Mock data for demonstration purposes
// In a real application, this would connect to an API
// Mock users
const mockUsers: User[] = [
  {
    id: '1',
    name: 'Erik de Vries',
    role: UserRole.INSTRUCTOR,
    team: 'Instructeurs',
    serviceCompensation: 195.0,
    kmCompensation: 0.23,
    email: 'e.devries@vvgn.nl',
    phone: '06-12345678',
    active: true,
  },
  {
    id: '2',
    name: 'Lisa Bakker',
    role: UserRole.INSTRUCTOR,
    team: 'Instructeurs',
    serviceCompensation: 195.0,
    kmCompensation: 0.23,
    email: 'l.bakker@vvgn.nl',
    phone: '06-23456789',
    active: true,
  },
  {
    id: '3',
    name: 'Planner001',
    role: UserRole.PLANNER,
    team: 'Planners',
    serviceCompensation: 0,
    kmCompensation: 0,
    email: 'planner001@vvgn.nl',
    active: true,
  },
  {
    id: '4',
    name: 'Manager001',
    role: UserRole.MANAGER,
    team: 'Management',
    serviceCompensation: 0,
    kmCompensation: 0,
    email: 'manager001@vvgn.nl',
    active: true,
  },
]
// Mock projects
const mockProjects: Project[] = [
  {
    id: '1',
    projectNumber: '52001',
    clientName: 'DHL Express Netherlands',
    location: {
      address: 'Lulofstraat 112',
      postalCode: '2521 AM',
      city: 'Den Haag',
      travelDistance: 45,
    },
    costCenter: 'KP007',
    costBearer: '510379',
    contactPerson: 'Jan Janssen',
    contactEmail: 'j.janssen@dhl.com',
    contactPhone: '070-1234567',
    startDate: new Date(2023, 0, 1),
    status: ProjectStatus.ACTIVE,
  },
  {
    id: '2',
    projectNumber: '52002',
    clientName: 'ProRail',
    location: {
      address: 'Stationsplein 1',
      postalCode: '3511 ED',
      city: 'Utrecht',
      travelDistance: 30,
    },
    costCenter: 'KP008',
    costBearer: '510380',
    contactPerson: 'Petra Peters',
    contactEmail: 'p.peters@prorail.nl',
    contactPhone: '030-1234567',
    startDate: new Date(2023, 1, 15),
    status: ProjectStatus.ACTIVE,
  },
  {
    id: '3',
    projectNumber: '52003',
    clientName: 'Shell Nederland',
    location: {
      address: 'Carel van Bylandtlaan 30',
      postalCode: '2596 HR',
      city: 'Den Haag',
      travelDistance: 40,
    },
    costCenter: 'KP009',
    costBearer: '510381',
    contactPerson: 'Sander de Boer',
    contactEmail: 's.deboer@shell.com',
    contactPhone: '070-9876543',
    startDate: new Date(2023, 2, 1),
    status: ProjectStatus.ACTIVE,
  },
]
// Create dates for this week
const today = new Date()
const startOfWeek = new Date(today)
startOfWeek.setDate(today.getDate() - today.getDay() + 1) // Start from Monday
// Mock training services
const mockTrainingServices: TrainingService[] = [
  {
    id: '1',
    serviceType: ServiceType.HALF_DAY_MORNING,
    startTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate(),
      9,
      0,
    ),
    endTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate(),
      12,
      30,
    ),
    breakDuration: 15,
    description: 'Chariot training DHL Express',
    specialNotes: 'Deelnemers moeten veiligheidsschoenen dragen',
    requiresProtocol: true,
    trainingType: TrainingType.OWT,
    assignedUserId: '1', // Erik de Vries
    projectId: '1', // DHL
    createdBy: '3', // Planner001
    createdAt: new Date(2023, 0, 15),
    updatedAt: new Date(2023, 0, 15),
    status: ServiceStatus.CONFIRMED,
  },
  {
    id: '2',
    serviceType: ServiceType.HALF_DAY_AFTERNOON,
    startTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 1,
      13,
      0,
    ),
    endTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 1,
      16,
      30,
    ),
    breakDuration: 15,
    description: 'Defensief rijden training ProRail',
    specialNotes: '',
    requiresProtocol: false,
    trainingType: TrainingType.DEFENSIVE_DRIVING,
    assignedUserId: '2', // Lisa Bakker
    projectId: '2', // ProRail
    createdBy: '3', // Planner001
    createdAt: new Date(2023, 0, 20),
    updatedAt: new Date(2023, 0, 20),
    status: ServiceStatus.CONFIRMED,
  },
  {
    id: '3',
    serviceType: ServiceType.FULL_DAY,
    startTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 2,
      9,
      0,
    ),
    endTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 2,
      17,
      0,
    ),
    breakDuration: 45,
    description: 'Sliptraining Shell Nederland',
    specialNotes: 'Deelnemers moeten rijbewijs B meenemen',
    requiresProtocol: true,
    trainingType: TrainingType.SLIPTRAINING,
    assignedUserId: '1', // Erik de Vries
    projectId: '3', // Shell
    createdBy: '3', // Planner001
    createdAt: new Date(2023, 0, 25),
    updatedAt: new Date(2023, 0, 25),
    status: ServiceStatus.CONFIRMED,
  },
  {
    id: '4',
    serviceType: ServiceType.HALF_DAY_MORNING,
    startTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 3,
      9,
      0,
    ),
    endTime: new Date(
      startOfWeek.getFullYear(),
      startOfWeek.getMonth(),
      startOfWeek.getDate() + 3,
      12,
      30,
    ),
    breakDuration: 15,
    description: 'Code 95 training DHL',
    specialNotes: '',
    requiresProtocol: false,
    trainingType: TrainingType.CODE_95,
    assignedUserId: '2', // Lisa Bakker
    projectId: '1', // DHL
    createdBy: '3', // Planner001
    createdAt: new Date(2023, 0, 30),
    updatedAt: new Date(2023, 0, 30),
    status: ServiceStatus.PLANNED,
  },
]
// Mock roster entries
const mockRosterEntries: RosterEntry[] = mockTrainingServices.map(
  (service) => ({
    id: service.id,
    date: service.startTime,
    timeSlot: `${service.startTime.getHours()}:${service.startTime.getMinutes().toString().padStart(2, '0')} - ${service.endTime.getHours()}:${service.endTime.getMinutes().toString().padStart(2, '0')}`,
    scheduledBy:
      mockUsers.find((u) => u.id === service.createdBy)?.name || 'Unknown',
    notes: service.specialNotes,
    teamNotesVisible: true,
    trainingServiceId: service.id,
    weatherForecast: {
      temperature: 15 + Math.floor(Math.random() * 10),
      condition: ['Sunny', 'Cloudy', 'Rainy', 'Partly Cloudy'][
        Math.floor(Math.random() * 4)
      ],
      precipitation: Math.floor(Math.random() * 100),
      windSpeed: 5 + Math.floor(Math.random() * 20),
    },
  }),
)
// Service class
class DataService {
  // Users
  getUsers(): User[] {
    return [...mockUsers]
  }
  getUserById(id: string): User | undefined {
    return mockUsers.find((user) => user.id === id)
  }
  getUsersByRole(role: UserRole): User[] {
    return mockUsers.filter((user) => user.role === role)
  }
  // Projects
  getProjects(): Project[] {
    return [...mockProjects]
  }
  getProjectById(id: string): Project | undefined {
    return mockProjects.find((project) => project.id === id)
  }
  // Training Services
  getTrainingServices(): TrainingService[] {
    return [...mockTrainingServices]
  }
  getTrainingServiceById(id: string): TrainingService | undefined {
    return mockTrainingServices.find((service) => service.id === id)
  }
  getTrainingServicesByUser(userId: string): TrainingService[] {
    return mockTrainingServices.filter(
      (service) => service.assignedUserId === userId,
    )
  }
  getTrainingServicesByProject(projectId: string): TrainingService[] {
    return mockTrainingServices.filter(
      (service) => service.projectId === projectId,
    )
  }
  getTrainingServicesByDateRange(
    startDate: Date,
    endDate: Date,
  ): TrainingService[] {
    return mockTrainingServices.filter(
      (service) =>
        service.startTime >= startDate && service.startTime <= endDate,
    )
  }
  // Roster
  getRosterEntries(): RosterEntry[] {
    return [...mockRosterEntries]
  }
  getRosterEntryById(id: string): RosterEntry | undefined {
    return mockRosterEntries.find((entry) => entry.id === id)
  }
  getRosterEntriesByDateRange(startDate: Date, endDate: Date): RosterEntry[] {
    return mockRosterEntries.filter(
      (entry) => entry.date >= startDate && entry.date <= endDate,
    )
  }
  // Helper methods
  getFullTrainingDetails(serviceId: string): {
    service: TrainingService | undefined
    project: Project | undefined
    instructor: User | undefined
    rosterEntry: RosterEntry | undefined
  } {
    const service = this.getTrainingServiceById(serviceId)
    const project = service ? this.getProjectById(service.projectId) : undefined
    const instructor = service
      ? this.getUserById(service.assignedUserId)
      : undefined
    const rosterEntry = this.getRosterEntryById(serviceId)
    return {
      service,
      project,
      instructor,
      rosterEntry,
    }
  }
}
export const dataService = new DataService()
